import { store } from './store';
import authActions from 'modules/redux/auth/actions';

export default () =>
  new Promise(() => {
    // store.dispatch(authActions.checkAuthorization());
});
